export default {
  home: {
    title: "Formación",
    subtitle:
      "Consejos y lecturas que impulsarán tu empresa a su mejor versión",
    cards: {
      Web: {
        title: "¿Cómo comienzo a crear mi sitio web en la plataforma?",
        subtitle:
          "Comienza tu viaje digital en Lázzaro Emprende de manera fácil y rápida. Con nuestra interfaz intuitiva, simplemente elige tu diseño, personaliza tu contenido y publica tu sitio web en cuestión de minutos."
      },
      Support: {
        title: "¿La plataforma ofrece soporte técnico en caso de problemas?",
        subtitle:
          "En Lázzaro Emprende, nuestro equipo especializado está listo para brindarte apoyo técnico siempre que lo necesites. Con asistencia dedicada, resolvemos tus inquietudes y te ayudamos a superar cualquier desafío técnico."
      },
      Advisor: {
        title: "Sácale partido a tu asesor",
        subtitle:
          "Nuestros asesores especializados están listos para ofrecerte orientación estratégica y soluciones adaptadas a tus necesidades. Desde consejos sobre diseño web hasta estrategias de marketing digital"
      },
      SEO: {
        title:
          "¿Qué estrategias puedo usar para mejorar mi posicionamiento SEO en la plataforma?",
        subtitle:
          "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
      },
      Content: {
        title: "¿Qué tipo de contenido es más efectivo para mi web?",
        subtitle:
          "Aprovecha para compartir, información útil sobre tus servicios, testimonios impactantes, imágenes de calidad y contenido multimedia, creando así una experiencia enriquecedora que conecte emocionalmente con tus visitantes"
      },
      Events: {
        title: "¿Cómo puedo agregar y promocionar eventos en mi sitio web?",
        subtitle:
          "Utiliza nuestra herramienta intuitiva para crear y publicar eventos, agrega detalles relevantes, incluye imágenes atractivas y comparte en redes sociales. Así podrás llegar a tu audiencia, promover tus eventos y garantizar una participación exitosa."
      },
      Blog: {
        title: "¿Cómo creo y administro contenido para el blog?",
        subtitle:
          "Accede a nuestro panel, crea entradas de blog con facilidad e incorpora imágenes. Así mantendrás a tu audiencia informada y comprometida con contenido relevante y atractivo."
      },
      Portfolio: {
        title: "¿Cómo puedo mostrar mi trabajo en mi portfolio?",
        subtitle:
          "Exhibir tu trabajo en el portfolio es simple. Carga tus proyectos con descripciones detalladas, imágenes llamativas y enlaces relevantes. Presenta tu mejor trabajo, cautivando a potenciales clientes con tu experiencia y habilidades destacadas."
      }
    }
  },
  Web: {
    subtitle: "Diseña tu web",
    style: {
      title: "Selecciona tu estilo",
      subtitle:
        "Explora la variedad de diseños disponibles y elige el que mejor se adapte a tus necesidades."
    },
    customize: {
      title: "Personaliza tu contenido",
      subtitle:
        "Modifica el texto, las imágenes y otros elementos de la página para reflejar la identidad de tu negocio. Añade secciones relevantes como Quiénes Somos y Porqué elegirnos."
    },
    functionalities: {
      title: "Añade funcionalidades",
      subtitle:
        "Incorpora secciones útiles como reservas, eventos, reseñas, tienda online, entre otros, completando con imágenes e información, según las necesidades de tu negocio."
    },
    review: {
      title: "Prueba y revisa",
      subtitle:
        "Antes de publicar, revisa tu sitio web para asegurarte de que todos los elementos estén correctos y se vean como deseas haciendo clic en Ver web."
    },
    publish: {
      title: "Publica tu sitio",
      subtitle:
        'Una vez satisfecho con la apariencia y funcionalidad, haz clic en "Publicar" para poner tu sitio web en línea y disponible para tus clientes.'
    }
  },
  Support: {
    // TODO: Change subtitles once design is ready
    subtitle: "Soporte técnico de la plataforma",
    button: {
      title: "Accede a la ayuda",
      subtitle:
        "Si tienes problemas técnicos, haz clic en el botón de ayuda para acceder a nuestro equipo de soporte técnico."
    },
    contact: {
      title: "Contacta con el equipo de soporte",
      subtitle:
        "Nuestro equipo de soporte técnico está disponible para ayudarte con cualquier problema que puedas tener."
    },
    describe: {
      title: "Describe tu problema",
      subtitle:
        "Cuando contactes con el equipo de soporte, describe tu problema con la mayor precisión posible para que podamos ayudarte de la mejor manera."
    },
    personalized: {
      title: "Recibe asistencia personalizada",
      subtitle:
        "Nuestro equipo de soporte técnico te ayudará a resolver cualquier problema que puedas tener con la plataforma según tus necesidades."
    }
  },
  SEO: {
    subtitle: "Posicionamiento en SEO",
    keywords: {
      title: "Investigación de palabras clave",
      subtitle:
        "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
    },
    content: {
      title: "Contenido relevante y de calidad",
      subtitle:
        "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
    },
    images: {
      title: "Optimización de imágenes",
      subtitle:
        "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
    },
    links: {
      title: "Enlaces externos",
      subtitle:
        "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
    },
    tools: {
      title: "Herramientas integradas",
      subtitle:
        "Optimiza tu contenido utilizando palabras clave relevantes, crea contenido de calidad, utiliza etiquetas y metadescripciones, y aprovecha nuestras herramientas integradas para mejorar tu visibilidad online."
    }
  },
  Content: {
    subtitle: "Contenido efectivo",
    info: {
      title: "Información detallada",
      subtitle:
        "Describe detalladamente tus servicios, productos, eventos, etc. Utiliza un lenguaje claro y accesible para explicar cómo pueden beneficiar a tus usuarios."
    },
    testimonials: {
      title: "Testimonios y opiniones",
      subtitle:
        "Destaca los testimonios de clientes satisfechos. Los testimonios auténticos y positivos son una poderosa herramienta para generar confianza y credibilidad."
    },
    images: {
      title: "Imágenes de alta calidad",
      subtitle:
        "Utiliza imágenes de alta resolución y relevantes que resalten tu marca, productos o servicios. Las imágenes de calidad captan la atención y hacen que tu contenido sea más atractivo."
    },
    stories: {
      title: "Historias y contenido emotivo",
      subtitle:
        "Comparte historias, casos de éxito o contenido que conecte emocionalmente con tus visitantes. Este tipo de contenido puede generar una relación más cercana y duradera con tu audiencia."
    },
    blog: {
      title: "Publicaciones de blog relevantes",
      subtitle:
        "Escribe publicaciones de blog informativas y útiles que aborden temas relevantes para tu audiencia. Esto ayuda a establecerte como una autoridad en tu área y mejora el SEO de tu sitio."
    }
  },
  Events: {
    subtitle: "Crear eventos en mi web",
    create: {
      title: "Creación de eventos",
      subtitle:
        "Accede a la herramienta de Lázzaro Emprende para crear eventos. Completa los detalles esenciales como el título del evento, fecha, hora, ubicación y una descripción completa."
    },
    images: {
      title: "Imágenes atractivas",
      subtitle:
        "Agrega imágenes de alta calidad relacionadas con el evento. Las imágenes atractivas pueden captar la atención de los usuarios y generar interés."
    },
    details: {
      title: "Detalles relevantes",
      subtitle:
        "Proporciona información relevante sobre el evento, como el programa, los ponentes, los temas a tratar y cualquier otra información que pueda resultar importante para los asistentes potenciales."
    },
    promote: {
      title: "Promoción en redes sociales",
      subtitle:
        "Comparte tus eventos en tus redes sociales. Aprovecha plataformas como Facebook, Twitter o LinkedIn para llegar a una audiencia más amplia y promover la participación."
    },
    reminders: {
      title: "Recordatorios y seguimientos",
      subtitle:
        "Envía recordatorios a través de correos electrónicos o mensajes para mantener a tus suscriptores informados sobre los eventos. El seguimiento y la comunicación son clave para aumentar la participación."
    }
  },
  Blog: {
    subtitle: "Crear y administrar contenido para el blog",
    create: {
      title: "Crear entradas de blog",
      subtitle:
        "Utiliza la interfaz intuitiva para crear nuevas entradas de blog. Agrega títulos llamativos y redacta contenido relevante y atractivo para tu audiencia."
    },
    images: {
      title: "Incorporar imágenes",
      subtitle:
        "Enriquece tus publicaciones con imágenes relevantes y multimedia si es necesario. Las imágenes visualmente atractivas pueden captar la atención de los lectores y mejorar la experiencia de lectura."
    },
    publish: {
      title: "Publicación",
      subtitle:
        "Publica tus artículos inmediatamente para incluirlos en tu blog"
    },
    seo: {
      title: "Optimización SEO",
      subtitle:
        "Utiliza palabras clave relevantes en tus publicaciones para mejorar su visibilidad en los motores de búsqueda y atraer más tráfico a tu sitio."
    },
    promote: {
      title: "Promoción en redes sociales",
      subtitle:
        "Comparte tus publicaciones de blog en tus redes sociales para llegar a una audiencia más amplia y aumentar la visibilidad del contenido."
    }
  },
  Portfolio: {
    subtitle: "Crear eventos en mi web",
    create: {
      title: "Cargar proyectos al portfolio",
      subtitle:
        "Utiliza la sección designada para el portfolio e ingresa los detalles de tus proyectos. Añade descripciones detalladas que destaquen los aspectos más relevantes de cada proyecto."
    },
    images: {
      title: "IMÁGENES LLAMATIVAS",
      subtitle:
        "Acompaña cada proyecto con imágenes atractivas que muestren visualmente tu trabajo. Las imágenes de alta calidad pueden captar la atención y realzar la presentación."
    },
    featured: {
      title: "LO MEJOR DE TU TRABAJO",
      subtitle:
        "Selecciona y exhibe tus proyectos más destacados. Destaca aquellos que demuestren tus habilidades y experiencia de manera sobresaliente."
    },
    clients: {
      title: "CAUTIVA POTENCIALES CLIENTES",
      subtitle:
        "Utiliza tu portfolio como una vitrina para atraer nuevos clientes. Muestra tus habilidades, experiencia y creatividad para destacarte entre la competencia."
    }
  }
};
